import React, { useRef } from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DownloadButton from "./Buttons/ButtonDownload";

type VideoModalProps = {
  url: string;
  isOpen: boolean;
  onClose: () => void;
  fileName: string;
};

const VideoModal: React.FC<VideoModalProps> = ({ url, isOpen, onClose, fileName }) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  const handleFullscreen = () => {
    if (videoRef.current) {
      if (videoRef.current.requestFullscreen) {
        videoRef.current.requestFullscreen();
      }
    }
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: { bgcolor: "black", borderRadius: 2, overflow: "hidden" },
      }}
    >
      {/* Close Button */}
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: "white",
          zIndex: 1,
          backgroundColor: "rgba(0,0,0,0.5)",
          "&:hover": { backgroundColor: "rgba(0,0,0,0.7)" },
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ p: 0 }}>
        <Box sx={{ position: "relative" }}>
          <video
            ref={videoRef}
            src={url}
            controls
            autoPlay
            style={{
              width: "100%",
              height: "auto",
              borderRadius: "8px",
            }}
          />
          {/* Fullscreen Button */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", p: 1, gap: 1 }}>
            {/* <DownloadButton
              fileUrl={url}
              fileName={fileName}
              startIcon={<FileDownloadIcon />}
              variant="contained"
              color="success"
              size="large"
            >
              Download
            </DownloadButton> */}
            <Button
              variant="contained"
              color="success"
              startIcon={<FullscreenIcon />}
              onClick={handleFullscreen}
            >
              Fullscreen
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default VideoModal;
